import { PiWarningBold } from 'react-icons/pi'

import { duration } from '@/insights/common/formatUtils'

import DetailCard from './DetailCard'
import RowsTable from './RowsTable'
import { formatDate } from './utils'

export interface ActiveAlert {
  name: string
  severity: string
  raisedTime: string
}

export const formatSeverity = (severity: string) =>
  severity === 'critical'
    ? 'Critical'
    : severity === 'warning'
      ? 'Warning'
      : severity === 'informational' || severity === 'information'
        ? 'Info'
        : severity

export const severityColor: Record<string, string> = {
  critical: 'text-[#C51616] bg-error/30 border border-error px-2 rounded-md text-xs',
  warning: 'text-[#A37B00] bg-warning/30 border-warning border px-2 rounded-md text-xs',
  informational: 'text-[#2A693A] bg-info/30 border px-2 rounded-md border-info text-xs',
  information: 'text-[#2A693A] bg-info/30 border px-2 rounded-md border-info text-xs',
}

export const severityPill = (severity: string) => (
  <span className={severityColor[severity]}>{formatSeverity(severity)}</span>
)

/**
 * The cold-storage modals' alerts, in the same table as the asset detail's Alerts & Alarms
 * tab. There is no Raised Location column: a cold-storage location doesn't move.
 */
export default function ActiveAlertsCard({ alerts, className }: { alerts: ActiveAlert[]; className?: string }) {
  return (
    <DetailCard title="Active Alerts" icon={<PiWarningBold />} className={className}>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <RowsTable
          columns={[
            { header: 'Severity' },
            { header: 'Alert' },
            { header: 'Raised', className: 'whitespace-nowrap' },
            { header: 'Duration', className: 'whitespace-nowrap' },
          ]}
          rows={alerts.map((alert) => [
            severityPill(alert.severity),
            <span className="font-bold">{alert.name}</span>,
            formatDate(alert.raisedTime),
            duration(alert.raisedTime),
          ])}
          empty="No Active Alerts"
        />
      </div>
    </DetailCard>
  )
}
